/* REPS theme — interactivity */
(function () {
  /* ---- Mobile nav ---- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var pill = document.querySelector('[data-nav-pill]');
    if (!toggle || !pill) return;
    if (toggle.dataset.bound) return;
    toggle.dataset.bound = '1';
    toggle.addEventListener('click', function () {
      pill.classList.toggle('open');
      toggle.setAttribute('aria-expanded', pill.classList.contains('open') ? 'true' : 'false');
    });
  }

  /* ---- Scroll-through value cards ----
     Cards enter from the right, pass through center, exit left,
     scrubbed to the section's progress through the viewport. */
  function initScrollCards() {
    var groups = document.querySelectorAll('[data-scroll-cards]');
    if (!groups.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var baseRot = [-2, 1.5, -1];
    var ticking = false;

    function frame() {
      var vh = window.innerHeight;
      var vw = window.innerWidth;
      var enabled = vw > 1024 && !reduce;

      groups.forEach(function (group) {
        var cards = group.querySelectorAll('.pcard');

        if (!enabled) {
          cards.forEach(function (c) { c.style.transform = ''; c.style.opacity = ''; });
          return;
        }

        var rect = group.getBoundingClientRect();
        var p = (vh - rect.top) / (rect.height + vh); // 0 entering -> 1 exited
        p = Math.max(0, Math.min(1, p));

        var STAGGER = 0.035;                    // lower = cards stay closer together
        var maxStagger = STAGGER * Math.max(cards.length - 1, 1);

        cards.forEach(function (card, i) {
          var stagger = i * STAGGER;            // each card trails the previous
          var local = (p - stagger) / (1 - maxStagger);
          local = Math.max(0, Math.min(1, local));

          var t = (local - 0.5) * 2;            // -1 (right) .. 0 (center) .. 1 (left)
          var x = -t * (vw * 0.72);             // horizontal travel in px

          // --- wiggle: subtle wobble + bob while the card is in motion ---
          var travel = Math.abs(t);             // 0 at center, 1 at edges
          var ease = 1 - travel;                // strongest near center, calm at edges
          var phase = i * 1.4;                  // offset each card so they don't sync
          var wig = Math.sin(t * Math.PI * 3 + phase) * 2.2 * ease;   // extra degrees
          var bob = Math.sin(t * Math.PI * 2 + phase) * 9 * ease;     // px vertical

          var rot = baseRot[i % baseRot.length] + (t * -5) + wig;

          card.style.transform = 'translateX(' + x.toFixed(1) + 'px) translateY(' + bob.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg)';

          var edge = 0.82;                      // fade only near the far edges
          var op = Math.abs(t) > edge ? Math.max(0, 1 - (Math.abs(t) - edge) / (1 - edge)) : 1;
          card.style.opacity = op.toFixed(3);
        });
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { frame(); ticking = false; });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  function init() { initNav(); initScrollCards(); }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  document.addEventListener('shopify:section:load', init);
})();